"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SsiHeader = SsiHeader;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../constants/icons");

var _HorizontalFlex = require("../containers/HorizontalFlex");

var _PadContainer = require("../containers/PadContainer");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function SsiHeader(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "ssi-header"
    },
    /*#__PURE__*/
    _react["default"].createElement(_PadContainer.PadContainer, {
      cssClassModifiers: ['pad-medium', 'no-pad-top-bottom']
    },
    /*#__PURE__*/
    _react["default"].createElement(_HorizontalFlex.HorizontalFlex, {
      cssClassModifiers: ['justify-center']
    },
    /*#__PURE__*/
    _react["default"].createElement("span", {
      className: "".concat(_icons.icons.security, " ssi-header__icon")
    }), props.ssiLabels.ssiHeader)))
  );
}

SsiHeader.propTypes = {
  ssiLabels: _propTypes["default"].instanceOf(Object).isRequired
};